module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "eccodarwin--dataset-cover.00d2a8bd.jpg";